/// <reference types="vite-plugin-svgr/client" />
import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";

import { Link } from "#/components/Link";

import ErrorIllustration from "./error-illustration.svg?react";

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  // eslint-disable-next-line no-console
  console.error(error);

  // @ts-ignore-next-line
  if (error.status === 401) {
    navigate(0);
  }

  return (
    <div className="flex flex-col md:flex-row space-y-8 md:space-y-0 items-center justify-center min-h-screen space-x-8 max-w-7xl mx-auto">
      <ErrorIllustration className="size-96" />
      <div className="text-center md:text-left md:w-1/2 p-4 flex flex-col space-y-4">
        <h1 className="text-2xl font-semibold text-primary mb-2">
          Oops! Algo deu errado.
        </h1>
        <p className="text-lg text-gray-800">
          Notificamos a equipe e estamos investigando o problema. Por favor,
          tente atualizar a página ou entre em contato com o suporte se o
          problema persistir.
        </p>

        <Link className="font-bold" to="/">
          Voltar para o início
        </Link>
      </div>
    </div>
  );
}
